import update from 'immutability-helper'
import clsx from 'clsx'
import React from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'

const useStyles = makeStyles(fillInTheBlanksStyles)

export default function FillInTheBlanks ({context, question}) {

  const classes = useStyles()
  const {quizAssessmentResults: assessment, translate} = context

  const {answers = {}} = assessment 
  const answer = answers[question.id] || {}

  return (<Box className={classes.root}>
    <Box className={classes.studentAnswer}>
      <Box className={classes.wrapper}>
        {answer.phrases.map(({phrase, blanked}, index) => (<Box key={index} className={clsx(classes.phrase, {blanked})}>{phrase}</Box>))}
      </Box>
    </Box>
    <Box className={classes.correctAnswer}>
      <Box className="label">
        <Box className={classes.correct}><CheckCircleIcon /></Box>
        <Box>{translate('expected-answer')}</Box>
      </Box>
      <Box className={classes.wrapper}>
        {question.answer.phrases.map(({phrase, blanked}, index) => (<Box key={index} className={clsx(classes.phrase, {blanked})}>{phrase}</Box>))}
      </Box>
    </Box>
  </Box>)

}


function fillInTheBlanksStyles (theme) {
  const verticalCentering = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  }

  return {
    root: {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'wrap',
      padding: '35px 0',
      fontSize: '12pt',
      "& .label": {
        display: "flex",
        marginBottom: 10 ,
        fontWeight: 'bold',
        '& > div': {
          ...verticalCentering
        }
      }
    },
    correct: {
      marginRight: 5,
      '& svg': {
        fill: '#27bc58',
      },
    },
    correctAnswer: {
      marginTop: 30
    },
    wrapper: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    phrase: {
      ...verticalCentering,
      marginRight: 10,
      '&:last-child': {
        marginLeft: 0
      },
      '&.blanked': {
        borderBottom: 'solid 1px black'
      },
    },
    input: {
        border: 'none',
        borderBottom: 'solid 1px black',
    },
  }
}
